export enum FleetType {  
  COVERAGE          = 2,
  FORMATION         = 3,
  FREE              = 4
}